// extracted by mini-css-extract-plugin
module.exports = {"container":"partner-link-group_container__l69ts","phAnimation":"partner-link-group_phAnimation__Q_IeU"};